import './HvacFormAreaCommentFormModal.scss';
import { useForm } from '@form-ts/react';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { Modal } from 'src/modules/common/components/Modal';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { TextAreaField } from 'src/modules/form/components/TextAreaField';
import { FormError } from 'src/modules/form/types/FormError';

type Props = {
  readonly isOpen: boolean;
  readonly comment: string;
  readonly onClose: () => void;
  readonly onSubmit: (comment: string) => void;
};

export const HvacFormAreaCommentFormModal = ({
  isOpen,
  comment,
  onSubmit,
  onClose,
}: Props): React.ReactElement => {
  const form = useForm<string, FormError>('hvac.comment', {
    reinitialize: true,
    initialValues: comment,
  });

  const handleSubmit = useCallback(() => {
    onSubmit(form.currentState.values);
  }, [form, onSubmit]);

  return (
    <Modal
      opened={isOpen}
      handleClose={onClose}
      size="md"
    >
      <ModalHeader
        handleClose={onClose}
        label={<FormattedMessage id="hvac/form/area/commentForm/header/title"/>}
        title={<FormattedMessage id="hvac/form/area/commentForm/header/subtitle"/>}
      />

      <ModalBody>
        <TextAreaField
          label={<FormattedMessage id="hvac/form/area/commentForm/body/label"/>}
          field={form.field}
          rows={3}
          maxLength={280}
        />
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          onClick={onClose}
          fullWidth={true}
        >
          <FormattedMessage id="schemaEdit/commentField/cancel"/>
        </Button>

        <Button
          kind="primary"
          autoFocus={true}
          fullWidth={true}
          onClick={handleSubmit}
        >
          <FormattedMessage id="schemaEdit/commentFieldTextEdit"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
};
